import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../environments/environment';

export const oktaAuth = new OktaAuth(environment.oktaConfig);
